import { readonly, shallowRef } from "vue";

import { projects as projectsApi } from "~/api";

/**
 * Composable for fetching a single project's detail (including jobs) as JSON.
 *
 * @param {string} projectId
 * @returns {{
 *   project: import('vue').DeepReadonly<import('vue').ShallowRef<object|null>>,
 *   loading: import('vue').DeepReadonly<import('vue').ShallowRef<boolean>>,
 *   error: import('vue').DeepReadonly<import('vue').ShallowRef<string|null>>,
 *   fetchProject: Function,
 *   clearError: Function
 * }}
 */
export function useProject(projectId) {
  const _project = shallowRef(null);
  const _loading = shallowRef(false);
  const _error = shallowRef(null);

  async function fetchProject() {
    _loading.value = true;
    _error.value = null;

    try {
      _project.value = await projectsApi.show({ params: { id: projectId } });
    } catch (err) {
      _error.value = err.message || "Oops, something went wrong!";
    } finally {
      _loading.value = false;
    }
  }

  function clearError() {
    _error.value = null;
  }

  return {
    clearError,
    error: readonly(_error),
    fetchProject,
    loading: readonly(_loading),
    project: readonly(_project)
  };
}
